import React from "react";
import WebView from "react-native-webview";
import { Platform } from "react-native";
import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export function ConnectAdminPreviewScreen(
  props: StoreAdminNavigationScreenProps<"ConnectAdminPreview">
) {
  const insets = useSafeAreaInsets();
  if (Platform.OS === "web") {
    return (
      <iframe
        src={props.route.params.url}
        style={{ width: "100%", height: "100%" }}
      />
    );
  }
  return (
    <WebView
      source={{
        uri: props.route.params.url,
      }}
      automaticallyAdjustContentInsets
      automaticallyAdjustsScrollIndicatorInsets
      allowsBackForwardNavigationGestures
      startInLoadingState
      decelerationRate={Platform.OS === "ios" ? "normal" : undefined}
      containerStyle={{
        paddingBottom: Platform.OS === "ios" ? insets.bottom : 0,
      }}
    />
  );
}
